module.exports = __webpack_public_path__ + "static/media/galeryAntihumidity14.10911227.jpg";